import type { SchoolDetail } from './types';

export const group4: Record<string, SchoolDetail> = {
  'the-english-manner': {
    slug: 'the-english-manner',
    lead:
      '英国の The English Manner は、バトラー専業校ではなく、エチケット・プロトコル教育の機関である。代表 William Hanson 氏のもと、Private Training や Group Masterclasses、オンライン講座、Train the Trainer など複数の形態で研修を提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The English Manner は、バトラー専業校ではなく、エチケット・プロトコル教育の機関です。執事教育の隣接分野として位置づけられます。公式サイト（theenglishmanner.com）を拠点に、対面・オンライン双方の研修を提供しています。',
      },
      {
        heading: '沿革と創設者',
        body: '代表は William Hanson 氏です。公式トップでは2026年で創立25年と示されています。一方、コースページには創立年・創設者の記載がありません（公式トップとコースページで記載に差異があります）。',
        bullets: [
          '代表: William Hanson 氏',
          '2026年で創立25年（公式トップ）',
          'コースページには創立年・創設者の記載なし',
        ],
        note: '創立年・創設者の記載は公式トップとコースページで差異あり。コースページ側には創立年・創設者の記載なし',
      },
      {
        heading: '開催地・拠点',
        body: 'Private Training および Group Masterclasses はロンドン中心部での対面開催が中心です。オンラインでの受講形態もあります。',
        table: [
          { label: '主な開催地', value: 'ロンドン中心部（対面）' },
          { label: 'その他', value: 'オンライン（ライブ／オンデマンド／動画）' },
          { label: '公式', value: 'https://theenglishmanner.com/' },
          { label: 'コース', value: 'https://theenglishmanner.com/courses/' },
        ],
      },
      {
        heading: '提供している課程',
        body: '公式が示す主なコースは次の4つです。',
        bullets: [
          'Private Training（ロンドン中心部での対面またはオンライン。受講者の目的に合わせてカリキュラムを個別設計）',
          'Group Masterclasses（半日または1日・ロンドン中心部・年1〜2回開催）',
          'Online Courses & Webinars（ライブ集合授業、オンデマンド、動画研修）',
          'Train the Trainer Grade One（オンライン・Beaumont Etiquette との提携。「世界で最も包括的な研修プログラム」と自ら称しています（自己申告））',
        ],
      },
      {
        heading: 'カリキュラムの科目',
        body: 'Private Training は受講者の目的に合わせてカリキュラムを個別設計します。Group Masterclasses は半日または1日、Online Courses & Webinars はライブ／オンデマンド／動画、Train the Trainer Grade One は Beaumont Etiquette との提携によるオンライン研修です。',
        note: '科目の詳細一覧は公式サイトに記載なし',
      },
      {
        heading: '学費と支払条件',
        note: '料金は公式サイトに記載なし',
      },
      {
        heading: '定員と受講対象',
        note: '定員・受講対象の具体的な条件は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        note: '応募資格・申込方法の詳細は公式サイトに記載なし',
      },
      {
        heading: '認定・受賞',
        body: '公式が示す所属・認定は次のとおりです。Train the Trainer に関し「世界で最も包括的な研修プログラム」と自ら称しています（自己申告）。',
        bullets: [
          'Forbes Business Council',
          'Leading Protocol & Etiquette Schools of the World',
          'Provider of Training Excellence（24-26）',
          'The Institute of Leadership 承認',
          'UK Register of Learning Providers 登録',
        ],
      },
      {
        heading: '修了後の進路と就職支援',
        note: '公式サイトに記載なし',
      },
      {
        heading: '言語',
        note: '使用言語の明記は公式サイトに記載なし',
      },
    ],
    sources: [
      { label: 'The English Manner 公式', url: 'https://theenglishmanner.com/' },
      { label: 'The English Manner コース', url: 'https://theenglishmanner.com/courses/' },
    ],
  },

  'modern-butlers-institute': {
    slug: 'modern-butlers-institute',
    lead:
      '米国拠点の国際機関 The International Institute of Modern Butlers。標語は「Teaching the Right Mindset, Interpersonal Skills, and Superior Service Experience」。業界標準の設定・引き上げを目的に業界関係者の要請で設立され、設立から二十年以上。私邸からヨット・航空・ホスピタリティまで幅広い訓練と関連サービスを提供する。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'The International Institute of Modern Butlers は、米国拠点の国際機関です。標語は「Teaching the Right Mindset, Interpersonal Skills, and Superior Service Experience」です。業界標準の設定・引き上げを目的に、業界関係者の要請で設立されたと記載されています。設立から二十年以上です。',
        bullets: [
          '標語: 「Teaching the Right Mindset, Interpersonal Skills, and Superior Service Experience」',
          '業界標準の設定・引き上げを目的に、業界関係者の要請で設立されたと記載',
          '設立から二十年以上',
        ],
      },
      {
        heading: '沿革と創設者',
        body: '業界標準の設定・引き上げを目的に、業界関係者の要請で設立されたと記載されています。設立から二十年以上です。',
        note: '設立年・創設者は公式サイトに記載なし',
      },
      {
        heading: '開催地・拠点',
        body: '米国拠点の国際機関として活動しています。オンサイト訓練（私邸・ジェット・ヨット、ホスピタリティ・病院・高齢者住宅など）やオンライン講座も提供します。',
        table: [{ label: '公式', value: 'https://www.modernbutlers.com/' }],
        note: '所在地の具体住所は公式サイトに記載なし',
      },
      {
        heading: '提供している課程',
        body: '公式が示す提供メニューは次のとおりです（19種）。',
        bullets: [
          '私邸・ヨット・ジェット向け訓練',
          '航空',
          'ホスピタリティ',
          '法人',
          'オンライン',
          'スパバトラー',
          '俳優向け指導',
          'コンサルティング',
          '品質管理',
          '私邸・ジェット・ヨットへのオンサイト訓練',
          'ホスピタリティ・病院・高齢者住宅へのオンサイト訓練',
          'Gold Seal プログラム',
          'オンライン講座（プライベートサービス）',
          'オンライン講座（ホスピタリティ）',
          'オンライン講座（ハウスキーピング）',
          'バトラーのインターンシップ',
          '就職斡旋',
          'ターンキーサービス',
          'Rent-a-Butler',
        ],
      },
      {
        heading: '学費と支払条件',
        note: '料金は公式サイトに記載なし',
      },
      {
        heading: '定員と受講対象',
        body: '私邸・ヨット・ジェット、航空、ホスピタリティ、法人など、幅広い領域のサービス専門職・組織を対象とします。',
        note: '定員・期間の具体数は公式サイトに記載なし',
      },
      {
        heading: '応募資格と申込方法',
        note: '応募資格・申込方法の詳細は公式サイトに記載なし',
      },
      {
        heading: '認定・受賞',
        body: '会員制度があります。認定の詳細は記載されていません。',
        bullets: ['会員制度あり'],
        note: '認定の詳細は公式サイトに記載なし',
      },
      {
        heading: '修了後の進路と就職支援',
        body: '就職斡旋、バトラーのインターンシップ、Rent-a-Butler などの関連サービスが公式に挙げられています。',
        bullets: ['就職斡旋', 'バトラーのインターンシップ', 'Rent-a-Butler'],
      },
      {
        heading: '言語',
        note: '使用言語は公式サイトに記載なし',
      },
    ],
    sources: [
      { label: 'The International Institute of Modern Butlers 公式', url: 'https://www.modernbutlers.com/' },
    ],
  },

  'dubai-butler-schools': {
    slug: 'dubai-butler-schools',
    lead:
      'アラブ首長国連邦・ドバイには、複数の執事教育機関が集積している。QE2 Hospitality Academy FZE、The British Butler Institute Dubai、SABA のドバイ拠点、Dubai Butler Academy などが挙げられる。ショートコースはおおむね3〜6日間が中心で、各校公式での個別確認が必要。',
    sections: [
      {
        heading: 'この学校の位置づけ',
        body: 'ドバイには複数の執事教育機関が集積しています。客船 Queen Elizabeth 2（QE2）を拠点とする機関や、国際的なバトラースクールの開催地としての拠点が含まれます。各校のショートコースはおおむね3〜6日間が中心であり、期間・料金・内容は各校公式で個別確認が必要です。',
        bullets: [
          'QE2 Hospitality Academy FZE',
          'The British Butler Institute Dubai',
          'SABA のドバイ拠点',
          'Dubai Butler Academy',
          'ショートコースはおおむね3〜6日間が中心（各校公式で個別確認が必要）',
        ],
      },
      {
        heading: 'QE2 Hospitality Academy FZE',
        body: 'Port Rashid の客船 QE2 を拠点とするホスピタリティ教育機関です。「ドバイ初かつ唯一の職業訓練型バトラー・ホスピタリティ学校」と自ら称しています（自己申告）。CTH（Confederation of Tourism & Hospitality）承認教育センターであり、カリキュラムはドバイ政府の認定機関の認証を受けていると記載されています。',
        table: [
          { label: '所在', value: 'Port Rashid CT-1 QE2 Ship, Dubai, UAE' },
          { label: '電話', value: '+971 4 888 1560' },
          { label: '公式', value: 'https://www.qe2academy.com/' },
          { label: '承認', value: 'CTH（Confederation of Tourism & Hospitality）承認教育センター' },
        ],
        bullets: [
          'Kitchen Professional（3か月・foundation / intermediate / advanced の3段階）',
          'カリキュラムはドバイ政府の認定機関の認証を受けていると記載',
          '「ドバイ初かつ唯一の職業訓練型バトラー・ホスピタリティ学校」と自ら称しています（自己申告）',
        ],
        note: 'バトラー課程の期間・料金は未確認',
      },
      {
        heading: 'The British Butler Institute Dubai',
        body: 'The British Butler Institute のドバイ拠点です。客船 Queen Elizabeth 2（QE2）のデッキ1に拠点を置き、船内で完結する没入型研修を掲げます。5日間のバトラースクール開催実績があります（2021年の公開資料）。',
        table: [
          { label: '拠点', value: '客船 QE2 デッキ1' },
          { label: '開催実績', value: '5日間のバトラースクール（2021年の公開資料）' },
        ],
      },
      {
        heading: 'SABA のドバイ拠点',
        body: 'SABA International Butler Academy & Training School は、南アフリカ、モルディブ、ジンバブエと並び、ドバイを開催国の一つとしています。ホテル向け訓練やレジデンシャル訓練など、SABA 本体のプログラム体系に沿った開催地として位置づけられます。',
        bullets: [
          '開催国の一つとしてドバイを列挙（南アフリカ・モルディブ・ジンバブエと並ぶ）',
        ],
        note: 'ドバイ開催の個別日程・料金の詳細は、SABA 公式の当該案内を確認する必要がある',
      },
      {
        heading: 'Dubai Butler Academy',
        body: 'Dubai Butler Academy の公式サイト（https://www.dubaibutleracademy.com/）は、2026-07-27 時点で HTTP 500 のためページ内容を取得できていません。',
        table: [{ label: '公式', value: 'https://www.dubaibutleracademy.com/' }],
        note: '2026-07-27 時点で HTTP 500 のためページ内容は未取得。課程・料金・所在地等は確認できず',
      },
      {
        heading: '提供している課程',
        body: '確認できている課程・開催形態の例は次のとおりです。ショートコースはおおむね3〜6日間が中心で、各校公式で個別確認が必要です。',
        bullets: [
          'QE2 Hospitality Academy: Kitchen Professional（3か月・foundation / intermediate / advanced）',
          'QE2 Hospitality Academy: バトラー課程（期間・料金は未確認）',
          'The British Butler Institute Dubai: 5日間のバトラースクール開催実績（2021年の公開資料）',
          'SABA: ドバイを開催国の一つとして実施',
          '各校のショートコースはおおむね3〜6日間が中心',
        ],
      },
      {
        heading: '学費と支払条件',
        note: '各校ともドバイ拠点におけるバトラー課程の料金は公式に確認できず（記載なしまたは未取得）。各校公式で個別確認が必要',
      },
      {
        heading: '定員と受講対象',
        note: '各校の定員・受講対象の詳細は、公式サイトに記載なしまたは未取得',
      },
      {
        heading: '認定・受賞',
        body: 'QE2 Hospitality Academy FZE について、次の記載があります。',
        bullets: [
          'CTH（Confederation of Tourism & Hospitality）承認教育センター',
          'カリキュラムはドバイ政府の認定機関の認証を受けていると記載',
          '「ドバイ初かつ唯一の職業訓練型バトラー・ホスピタリティ学校」と自ら称しています（自己申告）',
        ],
      },
      {
        heading: '修了後の進路と就職支援',
        note: '各校の就職支援の詳細は公式サイトに記載なしまたは未取得',
      },
      {
        heading: '言語',
        note: '使用言語は各校公式に記載なしまたは未取得',
      },
    ],
    sources: [
      { label: 'QE2 Hospitality Academy', url: 'https://www.qe2academy.com/' },
      {
        label: 'The British Butler Institute（Butler School）',
        url: 'https://www.britishbutlerinstitute.com/butler-school/',
      },
      { label: 'Dubai Butler Academy', url: 'https://www.dubaibutleracademy.com/' },
    ],
  },
};
